import React from 'react'
import { useNavigate } from 'react-router-dom'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { reExportedColors, EditModeButton, ITooltip } from '../1elements/'
import CloseFullView from '../1elements/Icons/js/CloseFullView'

const useStyles = makeStyles(() => ({
  layout: {
    width: '90vw',
    /* padding: 17px 22px 27px 21px; */
    margin: '25px 0 25px 100px',
    borderRadius: ' 0px 6px 6px 6px',
    display: 'grid',
    padding: '15px',
    paddingRight: '0px',
    gridGap: '5px',
    boxShadow: '0px 0px 3px #00000029',
    minHeight: '84vh',
    gridColumnGap: '25px',
    gridTemplateRows: '1fr 0.5fr 12fr',
    gridTemplateColumns: 'repeat(4, 1fr)'
  },
  top: {
    gridColumn: 'span 4',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)'
  },
  headName: {
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'Lato',
    color: reExportedColors.TEXT, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    gridColumn: 'span 3'
  },
  subName: {
    fontSize: '18px',
    fontWeight: 'bold',
    fontFamily: 'Lato',
    color: reExportedColors.TEXT, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    gridColumn: 'span 3'
  },
  goBackButtonfull: {
    backgroundColor: reExportedColors.MEDIUM_GREY, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    borderRadius: '4px 0px 0px 4px',
    transition: 'all 0.2s ease-in-out',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 28,
    height: 35,
    // marginTop: 30,
    boxShadow: '0px 0px 3px #00000029',
    marginLeft: '20px',
    cursor: 'pointer'
  },
  buttonsDiv: {
    // gridColumn: "-1 -2",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}))
export default function DetailsLayout ({ children, header, subHeader, onEditMode, setOnEditMode, disabled, className }) {
  const classes = useStyles()
  const navigate = useNavigate()
  return (
    <div className={`${classes.layout} ${className}`}>
      <div className={classes.top}>
        <div className={classes.headName}>{header}</div>
      </div>
      <div className={classes.subName}>{subHeader}</div>

      <div className={classes.buttonsDiv}>
        {
                    onEditMode !== undefined && <EditModeButton onEditMode={onEditMode} setOnEditMode={setOnEditMode} disabled={disabled} />
                }

        <div onClick={() => navigate(-1)} className={`go-back ${classes.goBackButtonfull}`}>
          <ITooltip placement='top-end' content='Go back  '>
            <CloseFullView width={18} height={13} />
          </ITooltip>
        </div>
      </div>
      {children}
    </div>
  )
}
